export var isArrNullOrEmpty = arrToCheck => !(arrToCheck === null || arrToCheck === void 0 ? void 0 : arrToCheck.length);